"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Olapic = void 0;
var _mui = require("@ori-ui/mui");
var _olapicLib = require("@ori/olapic-lib");
var _jsxRuntime = require("react/jsx-runtime");
// Replace fallback with skeleton after skeleton ready.
// Right now only dummy data will be updated after data from BE.
const Olapic = config => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.NoSsr, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_olapicLib.OlapicWidget, {
    ...config
  })
});
exports.Olapic = Olapic;
